const UPDATE_PROFILE = "UPDATE_PROFILE";

export { UPDATE_PROFILE };
